function SkeletonTextLines({ lines }) {
  const patterns = [
    ["poster-skeleton-text--wide"],
    ["poster-skeleton-text--wide", "poster-skeleton-text--mid"],
    ["poster-skeleton-text--wide", "poster-skeleton-text--mid", "poster-skeleton-text--narrow"],
  ];
  const cls = patterns[Math.min(Math.max(lines, 1), 3) - 1];
  return (
    <>
      {cls.map((c, idx) => (
        <span key={idx} className={`poster-skeleton-line ${c}`} aria-hidden />
      ))}
    </>
  );
}

export function HomePosterRowSkeleton({ count = 8, textLines = 1 }) {
  return (
    <div
      className="home-poster-row-with-arrows home-poster-row-skeleton-outer"
      aria-busy="true"
      aria-label="Loading titles"
    >
      <div className="home-poster-row poster-skeleton-row">
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className="home-poster-card home-poster-card--skeleton">
            <div className="home-poster-card-poster poster-skeleton-poster" />
            <SkeletonTextLines lines={textLines} />
          </div>
        ))}
      </div>
    </div>
  );
}

export function HomeTop10RowSkeleton({ count = 10 }) {
  return (
    <div
      className="home-poster-row-with-arrows home-poster-row-skeleton-outer"
      aria-busy="true"
      aria-label="Loading top titles"
    >
      <div className="home-poster-row home-top10-row poster-skeleton-row">
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className="home-top10-slot home-top10-slot--skeleton">
            <div className="home-top10-poster poster-skeleton-poster" />
            <span className="poster-skeleton-line poster-skeleton-text--wide home-top10-skeleton-title" aria-hidden />
          </div>
        ))}
      </div>
    </div>
  );
}

export function BrowseGridSkeleton({ count = 8 }) {
  return (
    <div className="browse-grid browse-grid--skeleton" aria-busy="true" aria-label="Loading titles">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="browse-card browse-card--skeleton">
          <div className="browse-card-poster poster-skeleton-poster" />
          <div className="browse-card-body browse-card-body--skeleton">
            <span className="poster-skeleton-line poster-skeleton-text--wide" aria-hidden />
            <span className="poster-skeleton-line poster-skeleton-text--narrow" aria-hidden />
          </div>
        </div>
      ))}
    </div>
  );
}
